// @flow

import type { OpenedIncomingPayment } from './types';

export function getSafeAllowedPaymentTypes(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const allowedPaymentTypes = incomingPayment['allowed_payment_types'];
  if(!allowedPaymentTypes)
    throw new Error('Allowed Payment Types: no allowed payment types for opened payment');

  return allowedPaymentTypes;
}
